import { requestAndParse } from '../request';

const getParticipantDocument = async (id: number) => {
    const route = 'admin/get-participant-document';
    const payload = { id };

    const response = await requestAndParse(route, payload, 'GET');

    return response.body as Blob;
};

export default getParticipantDocument;
